import React from 'react';
import { useTranslation } from 'react-i18next';
import { UploadedFile } from '../../../../types/chat';
import DocumentItem from '../../../../components/atoms/DocumentItem';
import LoaderSpin from '../../../../components/atoms/LoaderSpin';

interface FilePreviewProps {
  files: UploadedFile[];
  onRemove: (uid: string) => void;
}

const FilePreview = ({ files, onRemove }: FilePreviewProps) => {
  const { t } = useTranslation();
  const formatFileSize = (bytes: number) => {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${t(sizes[i])}`;
  };

  return (
    <div className="flex flex-wrap gap-2">
      {files.map((file) => (
        <div key={file.uid} className="relative">
          <DocumentItem
            title={file.name}
            sizeNumber={parseFloat(formatFileSize(file.size).split(' ')[0])}
            sizeType={formatFileSize(file.size).split(' ')[1]}
            documentUrl={URL.createObjectURL(new Blob([file.name]))}
            noDownload
            removeDoc={() => onRemove(file.uid)}
          />
          {file.status === 'uploading' && (
            <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
              <LoaderSpin />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FilePreview;
